import React from 'react'
import MainLayout from '../../containers/MainLayout'
import Vademecum from './components/Vademecum'
import Connect from './components/Connect'


import { connect } from 'react-redux'
import { langTexts } from './locals'

import './index.css'


const Professionals = props => {
  const { lang } = props.settings
    , texts = langTexts[lang]

  return <MainLayout id='healthcares'>
    <Vademecum texts={texts} lang={lang} />
    <Connect texts={texts} lang={lang} />
  </MainLayout>
}

const mapStateToProps = state => ({
  settings: state.settings
})

export default connect(mapStateToProps)(Professionals)